// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-blog-post-js": () => import("/tmp/602e8f71/src/templates/blog-post.js" /* webpackChunkName: "component---src-templates-blog-post-js" */),
  "component---src-templates-location-js": () => import("/tmp/602e8f71/src/templates/location.js" /* webpackChunkName: "component---src-templates-location-js" */),
  "component---src-pages-about-js": () => import("/tmp/602e8f71/src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-blog-js": () => import("/tmp/602e8f71/src/pages/blog.js" /* webpackChunkName: "component---src-pages-blog-js" */),
  "component---src-pages-index-js": () => import("/tmp/602e8f71/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

